module.exports = __webpack_public_path__ + "img/gchess.9a3c2db.webp";